/*###########################################################################
// CK tables
//#########################################################################*/

// Add wrapper to dynamic CMSable tables (for responsiveness)
//
const ckTables = document.querySelectorAll('.ck table')

if (ckTables !== null) {
	for (let i = 0; i < ckTables.length; i++) {
		const ckTable = ckTables[i]

		ckTable.outerHTML = '<div class="table-container">' + ckTable.outerHTML + '</div>'
	}
}

// Remove empty paragraphs from CK content
//
const ckParagraphs = document.querySelectorAll('.ck p')

if (ckParagraphs !== null) {
	for (let i = 0; i < ckParagraphs.length; i++) {
		const ckParagraph = ckParagraphs[i]

		if (ckParagraph.innerHTML === '' || ckParagraph.innerHTML === '&nbsp;') {
			ckParagraph.remove()
		}
	}
}
